var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ul',{staticClass:"settings-setup-checks-list",attrs:{"aria-label":_setup.ariaLabel}},_vm._l((_setup.shownChecks),function(setupCheck,index){return _c(_setup.SettingsSetupChecksListItem,{key:index,staticClass:"settings-setup-checks-list__item",attrs:{"setup-check":setupCheck}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }